import React from "react";
import { Box, Container, Divider, Typography, Link } from "@mui/material";

export default function FooterSmall(props) {
  return (
    <Box
      component="footer"
      sx={{
        pb: 6,
        width: "100%",
        // Logica per posizionamento assoluto o relativo
        position: props.absolute ? "absolute" : "relative",
        bottom: props.absolute ? 0 : "auto",
        backgroundColor: props.absolute ? "#1a202c" : "transparent", // bg-gray-900
        zIndex: 10
      }}
    >
      <Container maxWidth="lg">
        {/* Linea di separazione MUI */}
        <Divider sx={{ mb: 3, borderColor: "#2d3748" }} /> 
        
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: { xs: "center", md: "space-between" },
          }}
        >
          <Box sx={{ width: { xs: "100%", md: "auto" }, px: 2 }}>
            <Typography
              variant="body2"
              sx={{
                color: "#718096", // text-gray-600
                fontWeight: 500,
                py: 1,
                textAlign: { xs: "center", md: "left" },
                fontSize: "0.875rem",
              }}
            >
              Copyright © {new Date().getFullYear()}{" "}
              <Link
                href="https://www.crimerate.it/"
                target="_blank"
                rel="noopener"
                sx={{
                  color: "white",
                  textDecoration: "none",
                  fontWeight: 500,
                  "&:hover": { color: "#cbd5e0" }, // gray-400
                }}
              >
                Alex Corti (CRI Merate)
              </Link>
              {" - "}
              <Box component="span" sx={{ whiteSpace: "nowrap" }}>
                Versione {global.appVersion}
              </Box>
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}